module.exports = __webpack_public_path__ + "SourceSansPro-Italic.9e3e04d851b54b96ef03.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Italic.ttf
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Italic.ttf
// module chunks = styles